import { jsx as _jsx } from "react/jsx-runtime";
import { ChatPanel } from './ChatPanel';
/**
 * Standalone presentation: the conversation fills the viewport, centred and
 * width-capped on large screens. Same components, no launcher.
 */
export function StandaloneChat() {
    return (_jsx("div", { className: "ac-standalone", children: _jsx(ChatPanel, { mode: "inline" }) }));
}
